import { Text, ModalBody as VHSModalBody } from '@wistia/vhs';
import styled from 'styled-components';
import { isNotUndefined } from '~/utilities/type-guards';
import type { JSX } from 'react';
import type { ModalProps } from '../Modal';

type HeroContainerProps = Pick<ModalProps, 'height' | 'mediaType'>;
const HeroContainer = styled.div<HeroContainerProps>`
  /* parent component in VHSModal is flex and causes height to fluctuate */
  flex-grow: 0;
  flex-shrink: 0;
  width: auto;
  ${({ height }) => isNotUndefined(height) && `height: ${height}px;`}
  ${({ mediaType }) => mediaType === 'video' && 'aspect-ratio: 16 / 9;'}
`;

const StyledModalBody = styled(VHSModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.space04};
  height: 173px;
  margin-top: 0;
  padding: ${({ theme }) => theme.spacing.space06};
`;

export type HeroModalContentProps = HeroContainerProps &
  Pick<ModalProps, 'content' | 'header' | 'hero'> & {
    headerVariant?: 'headline1' | 'headline2' | 'headline3';
  };

export const HeroModalContent = ({
  header,
  content,
  hero,
  height,
  mediaType,
  headerVariant,
}: HeroModalContentProps): JSX.Element => {
  return (
    <>
      <HeroContainer
        height={height}
        mediaType={mediaType}
      >
        {hero}
      </HeroContainer>
      <StyledModalBody>
        <Text variant={headerVariant}>{header}</Text>
        <Text variant="body2">{content}</Text>
      </StyledModalBody>
    </>
  );
};
